import { ShieldCheck } from '@phosphor-icons/react/dist/ssr';
import MarkDownRender from './MarkdownRender';

import classNames from 'classnames';
import * as styles from '../PostCommentsFeed.css';
import { renderTime } from './renderTime';

interface Props {
  name: string;
  content: string;
  time: string;
  isModerator: boolean;
}

const CommentDisplay = ({ name, content, time, isModerator }: Props) => {
  return (
    <div className="flex flex-col items-start text-left">
      <div className="flex flex-col items-start">
        <p className={classNames(styles.commenterText, 'flex flex-row gap-x-2 items-center leading-5')}>
          <span className="flex flex-row gap-x-0.5 items-center">
            {name}
            {isModerator && <ShieldCheck className={classNames(styles.moderatorText, 'h-4 w-4')} weight="fill" />}
          </span>
          <span className={classNames(styles.timestampText, 'leading-4')}>{renderTime(time)}</span>
        </p>
        {isModerator && <span className={classNames(styles.moderatorText, 'leading-4')}>Author</span>}
      </div>
      <MarkDownRender className={classNames(styles.commentText)}>{content}</MarkDownRender>
    </div>
  );
};

export { CommentDisplay };
